import { W as WuiMenuPane$1, d as defineCustomElement$1 } from './p-DE-WBrSS.js';

const WuiMenuPane = WuiMenuPane$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMenuPane, defineCustomElement };
